const measurementId = process.env.REACT_APP_GOOGLE_ANALYTICS_ID;

let hasInitialized = false;

export function initializeAnalytics() {
  if (hasInitialized || typeof window === 'undefined' || !measurementId) {
    return;
  }

  // Ensure the global gtag helper exists before the analytics script loads.
  window.dataLayer = window.dataLayer || [];
  window.gtag =
    window.gtag ||
    function gtag() {
      window.dataLayer.push(arguments);
    };

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
  document.head.appendChild(script);

  window.gtag('js', new Date());
  window.gtag('config', measurementId, { send_page_view: false });

  hasInitialized = true;
}

export function logPageView(path) {
  if (typeof window !== 'undefined' && window.gtag && measurementId) {
    window.gtag('event', 'page_view', {
      page_path: path,
      page_location: window.location.origin + path
    });
  }
}

export function logEvent(eventName, properties = {}) {
  if (typeof window !== 'undefined' && window.gtag && measurementId) {
    window.gtag('event', eventName, properties);
  }

  const payload = [{ eventName, properties, occurredAt: new Date().toISOString() }];
  fetch('/api/events', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload)
  }).catch(() => {
    // ignore network errors for now
  });
}
